import React, {useState} from 'react';

import { CButton } from '@coreui/react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';

import { useStateContext } from '../../../../../../contextProvider';

import { downloadDocument } from '../../../../../../service-layer/StorageService';
import { toast, ToastContainer } from "react-toastify";


const DocumentButton = ( ) => {

  const { t } = useTranslation()

  const { selectedPatient, selectedDocument, documentURL, setDocumentURL, documentURLType, setDocumentURLType } = useStateContext()

  const downloadUserDocument = () => {
    // console.log("FILENAME", selectedDocument)

    downloadDocument(selectedPatient, selectedDocument).then(response => {
        console.log("FILE RESPONSE",response)

        if(response.status !== 200){
            setDocumentURL('downloadError')
            toast.error(t("downloadError"))
            return
        }

        // Process the response data as a Blob
        const fileBlob = new Blob([response.data], { type: response.data.type });


         // Create an object URL for the Blob
        const fileURL = URL.createObjectURL(fileBlob);
        console.log("FILE BLOB URL", fileURL)
        

        // Create a download link and trigger the download
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = selectedDocument;  // Set a default file name for the download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Clean up the DOM after triggering the download

        // Optionally revoke the object URL after the download is triggered
        URL.revokeObjectURL(fileURL);
    })
    .catch(err => {
        console.error(err)
        setDocumentURL("downloadError")
    })
  }

  const showPreviewDocument = () => {
    downloadDocument(selectedPatient, selectedDocument).then(response => {

        if(response.status !== 200){
            setDocumentURL('previewError')
            toast.error(t("previewError"))
        }

        // Process the response data as a Blob
        const fileBlob = new Blob([response.data], { type: response.data.type });

        setDocumentURLType(response.data.type)

         // Create an object URL for the Blob
        const fileURL = URL.createObjectURL(fileBlob);
        console.log("FILE BLOB URL", fileURL)
        setDocumentURL(fileURL)
    }
    )
    .catch((err) => {
        console.error(err);
        setDocumentURL('previewError')
    })
  } 

  return (
    <div style={{
        marginBottom: '2px',
        display: 'grid',
        gridTemplateColumns: '50% 50%',
        gap: '10px'
        }}>
        <CButton
            color='success'
            style={{
                width: '80%'
            }}
            onClick={downloadUserDocument}
        >
            <FontAwesomeIcon icon={faDownload} />
            {'  ' + t('downloadFile')}
        </CButton>
        <CButton
            color='secondary'
            style={{
                width: '80%'
            }}
            onClick={showPreviewDocument}
        >
            <FontAwesomeIcon icon={faEye} />
            {'  ' + t('previewFile')}
        </CButton>
    </div>
  )
}

export default DocumentButton